import { Box } from '@mui/material';
import { Outlet, useOutlet, useResolvedPath } from 'react-router-dom';
import { ListKeepAliveContext } from '../../hooks/listNavigation/ListKeepAliveContext';
import { useEntityImageListSync } from '../entityImage/entityImageListSync';

/**
 * Canonical list → detail layout.
 * The list stays mounted (hidden) while the nested fiche is shown.
 * Back / ← simply reveals the same cards, same scroll, same filters.
 */
export function ListKeepAlive({ children }) {
    useEntityImageListSync();
    const outlet = useOutlet();
    const listPath = useResolvedPath('.').pathname;
    const showingDetail = outlet != null;

    return (
        <ListKeepAliveContext.Provider value={{ listPath, isListVisible: !showingDetail }}>
            <Box
                aria-hidden={showingDetail}
                data-list-keep-alive={showingDetail ? 'hidden' : 'visible'}
                sx={showingDetail ? {
                    visibility: 'hidden',
                    position: 'absolute',
                    width: '100%',
                    pointerEvents: 'none',
                    zIndex: 0,
                } : { position: 'relative' }}
            >
                {children}
            </Box>
            <Outlet />
        </ListKeepAliveContext.Provider>
    );
}

export function keepListRoute(path, list, details) {
    return {
        path,
        element: <ListKeepAlive>{list}</ListKeepAlive>,
        children: details,
    };
}
